import { keyframes } from '@emotion/react';
import styled from '@emotion/styled';
import css from '@styled-system/css';
import shouldForwardProp from '@styled-system/should-forward-prop';
import { system } from 'styled-system';

const zeroToHundred = keyframes`
  0% { width: 0 }
  100% { width: 100% }
`;

const BrandedProgressBar = styled('div', {
  shouldForwardProp,
})(
  css({
    width: '100%',
    height: '10px',
    bg: 'brandedProgressBar',
    animation: `${zeroToHundred} 20s ease-in-out`,
  }),
  system({
    width: true,
  })
);

export default BrandedProgressBar;
